import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ApiResponse } from 'src/app/models/IApiResponse';
import { Observable, catchError } from 'rxjs';
import { ConfigErrorHandler } from 'src/app/shared/config.errorhandler';

@Injectable({
  providedIn: 'root'
})
export class UnbsChargesService {

  private baseURL = environment.apiURL;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json','Accept':'application/json' });

  constructor(
    private httpClient: HttpClient,
    private errorHandler: ConfigErrorHandler
  ) { }

  /**
   * Get vehicles pending UNBS charges
   * @returns Array
   */
  getvehiclesPendingUnbsCharges(): Observable<ApiResponse>{

    let apiURL:string=`${this.baseURL}/v1/vehicles/pending-unbs-charges`;

    return this.httpClient.get<ApiResponse>(apiURL).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Save UNBS charges
   * @param postData
   * @returns array
   */
  store(postData:any):Observable<any>{

    let apiURL:string=`${this.baseURL}/v1/post-unbs-charges-payment`;

    return this.httpClient.post(apiURL,postData, { headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }
}
